import React, { memo } from 'react';
import { CircleXIcon } from 'lucide-react';
import { Section } from './Shared';
const points = ['Recordás el punto de memoria pero no podés mostrárselo visualmente al paciente', 'Perdés tiempo buscando en libros técnicos densos durante o entre sesiones', 'Tenés el conocimiento pero no una herramienta rápida de consulta clínica', 'Tus pacientes no entienden qué punto les estás trabajando ni por qué', 'No tenés un recurso para que el paciente repita el protocolo en casa solo', 'Cada sesión depende de tu memoria en lugar de un sistema visual de respaldo', 'No contás con material para explicar los meridianos de forma sencilla y elegante', 'Improvisás la combinación de puntos porque no tenés fórmulas maestras a mano', 'Tus sesiones son efectivas pero no tienen la presentación premium que merecen', 'Cada consulta nueva arranca desde cero sin un sistema de referencia rápida'];
export function PainPoints() {
  return <Section className="max-w-4xl" data-id="element-253" data-mp="3nalchviyw3dq">
      <div className="text-center" data-id="element-254" data-mp="1z057z2t28qyk">
        <h2 className="font-display text-3xl font-bold leading-tight text-brand-ink md:text-5xl" data-id="element-255" data-mp="1yz3wwyc1o4gu">
          ¿Cuántos pacientes más vas a atender sin una herramienta clínica
          visual que respalde cada punto que aplicás?
        </h2>
        <div className="mx-auto mt-7 max-w-2xl space-y-4 text-sm leading-relaxed text-brand-text md:text-base" data-id="element-256" data-mp="23rdi6127sgcs">
          <p data-id="element-257" data-mp="1g1j4xidzgps0">
            Sos terapeuta. Practicante de Medicina Tradicional China. Estudiante
            avanzado o amante profundo de la medicina natural.
          </p>
          <p data-id="element-258" data-mp="1b4spmxa05y7n">
            Creés en el poder del toque. En la sabiduría del Qi. En que el
            cuerpo tiene todas las respuestas adentro.
          </p>
          <p className="font-semibold" data-id="element-259" data-mp="1k2cyara72wsa">
            Pero hay algo que nadie te dijo cuando empezaste:
          </p>
          <p className="font-semibold text-brand-forest" data-id="element-260" data-mp="30g31zwxejj1e">
            Conocer los puntos no es lo mismo que tener un sistema visual
            clínico para aplicarlos con precisión, velocidad y autoridad
            profesional.
          </p>
          <p className="font-serif text-lg italic text-brand-purple" data-id="element-261" data-mp="1y3zrl5390cdy">
            Y esa diferencia la sentís cada vez que:
          </p>
        </div>
      </div>
      <div className="glass-panel mt-10 rounded-3xl border-brand-purple/25 p-6 md:p-9" data-id="element-262" data-mp="226mnbh31ihgf">
        <h3 className="flex items-center gap-2 font-serif text-lg font-bold text-brand-ink" data-id="element-263" data-mp="274efmc7lk5l5">
          <CircleXIcon className="h-5 w-5 text-brand-burgundy" data-id="element-264" data-mp="1afyls3xgfa28" />
          LO QUE PASA SIN EL BOTIQUÍN ANCESTRAL™
        </h3>
        <ul className="mt-6 space-y-4" data-id="element-265" data-mp="1ee677c2v4zjr">
          {points.map(point => <li key={point} className="flex gap-3 text-sm leading-relaxed text-brand-text md:text-base" data-id="element-266" data-mp="1jdsk1kes4ds1">
              <CircleXIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-burgundy" aria-hidden="true" data-id="element-267" data-mp="qqy0cppsdifm" />
              {point}
            </li>)}
        </ul>
      </div>
      <p className="mt-10 text-center font-display text-2xl font-bold italic text-brand-purple md:text-3xl" data-id="element-268" data-mp="o6i7yyvrzsvh">
        ¿Y si esta fuera la última sesión que trabajás sin un sistema visual
        completo?
      </p>
    </Section>;
}